import React from 'react';
import { ActionsAssurance } from '../../../hooks';
import { Button, ButtonVariant, Spacer, SpacingRange } from '../../../styles';
import { useTranslation } from 'react-i18next';

export interface IEditAssuranceButtonProps {
    action: ActionsAssurance;
    libelleHorsEcran: string;
    spacerRange?: SpacingRange;
    noSpacer?: boolean;
    onEditAssurance: (action: ActionsAssurance) => void;
}

export const EditAssuranceButton: React.FC<IEditAssuranceButtonProps> = ({
    action,
    libelleHorsEcran,
    spacerRange = 1,
    noSpacer = false,
    onEditAssurance
}) => {
    const [t] = useTranslation(['ResumeAssurance']);

    return (
        <>
            <Button
                id={'QA_test_validation_assurance_modifier'}
                variant={ButtonVariant.compact}
                dataCy="qa-button-date-modifier"
                dataTestId={'bouton_modifier_assurance'}
                onClick={() => onEditAssurance(action)}
                srOnlySuffix={libelleHorsEcran}
            >
                {t('resumeChangeButton')}
            </Button>
            {!noSpacer && <Spacer all={spacerRange} />}
        </>
    );
};
